import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import CalendarDatePicker from "./CalendarDatePicker";
import dayjs from 'dayjs';
import CalendarTimePicker from "./CalendarTimePicker";
import moment from "moment";
import { AuthContext } from "../../../context";
import { env } from "../../../env";
import axios from "axios";
import Swal from "sweetalert2";
import MapComponent from "../../Dashboard/MapComponent";
import { useParams } from "react-router-dom";


const EventCopyModal = ({ eventDetails, setShowCopyViewModal, kindOfAppointmentList, appointmentTypeList, sendEventChildFromData }) => {
    const { t } = useTranslation();
    const {id} = useParams();
    const [isLoad, setIsLoad] = useState(false);
    const dropdownRef = useRef(null);
    const dropdownRef1 = useRef(null);
    const [showType, setShowType] = useState(false);
    const [showKindType, setShowKindType] = useState(false);
    const [showMap, setShowMap] = useState(false);
    const [markers, setMarkers] = useState(false);
    const authContext = useContext(AuthContext);
    const [inputs, setInputs] = useState({
        id: 0,
        userName: "",
        fromTime: "",
        toTime: "",
        appointmentDate: "",
        appointmentTypeIDs: [],
        kindOfAppointmentIDs: [],
        comment: ""
    });

    useEffect(() => {
        setInputs((prev) => ({
            ...prev,
            id: authContext.userInfo.id,
            userName: authContext.userInfo.userName,
            appointmentDate: eventDetails.start,
            fromTime: eventDetails.start,
            toTime: eventDetails.end,
            appointmentTypeIDs: eventDetails.appointmenttypes.length ?  eventDetails.appointmenttypeids.split(",").map(Number) : [],
            kindOfAppointmentIDs: eventDetails.kindofappointments.length ?  eventDetails.kindofappointmentids.split(",").map(Number) : []
        }));
        setMarkers([{geocode: eventDetails.geocode}]);
    }, [eventDetails]);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowType(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef1.current && !dropdownRef1.current.contains(event.target)) {
                setShowKindType(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleShowCreateModal = (e) => {
        e.preventDefault();
        setShowCopyViewModal();
    };
    const handleAppointmentType = (e, id) => {
        const checked = e.target.checked;
        setInputs((prev) => {
            const updatedTypes = checked
                ? [...prev.appointmentTypeIDs, id]
                : prev.appointmentTypeIDs.filter(typeId => typeId !== id);
            return { ...prev, appointmentTypeIDs: updatedTypes };
        });
    };
    const handleAppointmentKindType = (e, id) => {
        const checked = e.target.checked;
        setInputs((prev) => {
            const updatedKinds = checked
                ? [...prev.kindOfAppointmentIDs, id]
                : prev.kindOfAppointmentIDs.filter(kindId => kindId !== id);
            return { ...prev, kindOfAppointmentIDs: updatedKinds };
        });
    };
    const handleDateDataFromChild = (data) => {
        setInputs((prev) => ({
            ...prev,
            appointmentDate: data.date
        }));
    };
    const handleTimeDataFromChild = (data) => {
        setInputs((prev) => ({
            ...prev,
            fromTime: data.fromTime,
            toTime: data.toTime,
        }));
    };
    const handleChange = (e) => {
        setInputs((prev) => ({
            ...prev,
            comment: e.target.value
        }));
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        Swal.fire({
            title: `${ t("are you sure")}?`,
            text: `${ t("you want to create new appointment")}?`,
            width: 400,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: `${ t("yes")}!`,
            cancelButtonText: `${ t("cancel")}!`
        }).then((result) => {
            if (result.isConfirmed) { 
                setIsLoad(true);
                const baseUrl = env.REACT_APP_API_URL;
                const token = localStorage.getItem('token');      
                const requestData = {
                    "dayofweek": moment(inputs.appointmentDate).day(),
                    "merchandiserid": inputs.id,
                    "fromTime": moment(inputs.fromTime).format("HH:mm:00"),
                    "toTime": moment(inputs.toTime).format("HH:mm:00"),
                    "customerId": id,
                    "appointmentDate": moment(inputs.appointmentDate).format("DD-MM-YYYY"),
                    "comment": inputs.comment,
                    "appointmentTypeIDs": inputs.appointmentTypeIDs.join(","),
                    "kindOfAppointmentIDs": inputs.kindOfAppointmentIDs.join(","),
                    "iscomplete" : false,
                    "iscancel" : false
                }

                axios.post(baseUrl+"/api/ClientAppointments/CreateClientAppointment", requestData, {
                    headers : {
                        "Accept" : "Application/json",
                        "Content-Type" : "Application/json",
                        "Authorization" : `Bearer ${token}`,
                    }
                }).then((response) => {
                    if(response.data.success === "1") {
                        sendEventChildFromData("create");
                    }
                }).catch((error) => {
                    console.log(error);
                    setIsLoad(false);
                    if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                        localStorage.removeItem("token");
                        localStorage.removeItem("userInfo");
                        window.location.reload();
                    }
                });
            }
        });

    }

    return (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-end sm:items-center z-50">
            <form onSubmit={handleSubmit}>
                <div className="bg-white rounded-t-lg sm:rounded-lg shadow-lg w-[34rem] p-2 sm:p-6 space-y-2 sm:space-y-4">
                    <div className="flex justify-between items-center">
                        <div className='flex items-center space-x-2'>
                            <h3 className="text-lg font-semibold capitalize">
                                { t('create appointment')}
                            </h3>
                        </div>
                        <button type="button" onClick={(e) => (!isLoad && handleShowCreateModal(e))} className="text-gray-500 hover:text-gray-700">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"/>
                            </svg>
                        </button>
                    </div>
                    <div className='space-y-2'>
                        <div className='grid sm:grid-cols-2 gap-2'>
                            <div className='bg-gray-dark3 rounded-md p-4 h-full flex items-start space-x-2'>
                                <img className='w-5 h-5' src="../../assets/icons/profile/icon/type.svg" alt='type' />
                                <div className='ml-7 text-sm'>{eventDetails.customername}</div>
                            </div>
                            <div className='bg-gray-dark3 rounded-md p-4 h-full relative flex items-start space-x-2'>
                                <img className='w-5 h-5' src="../../assets/icons/profile/icon/location.svg" alt='location' />
                                <div className='ml-7 text-sm'>{eventDetails.address}</div>
                                <div onClick={(e) => setShowMap(!showMap)} className='absolute z-40 top-2 right-2 cursor-pointer'>
                                    <img className='bg-white p-2 rounded-md shadow-md' src="../../assets/icons/profile/icon/redirect.svg" alt='redirect' />
                                </div>
                            </div>
                        </div>
                        <div className='grid grid-cols-2 gap-2'>
                            <div className="space-y-1">
                                <div className='flex items-start space-x-2'>
                                    <label className='text-xs sm:text-sm capitalize text-light-700'>{t('appointment date')} :</label>
                                </div>
                                <div className='flex justify-between text-xs sm:text-sm bg-white border border-background-normal rounded-md px-4 py-2.5'>
                                    <CalendarDatePicker setDataFromChild={handleDateDataFromChild} startDate={dayjs()} dateInput={inputs.appointmentDate ? inputs.appointmentDate : dayjs()} name={'date'}/>
                                </div>
                            </div>
                            <div className="space-y-1">
                                <div className='flex items-start space-x-2'>
                                    <label className='text-xs sm:text-sm capitalize text-light-700'>{t('appointment time')} :</label>
                                </div>
                                <div className='flex justify-between text-xs sm:text-sm bg-white border border-background-normal rounded-md px-4 py-2.5'>
                                    <CalendarTimePicker startDateTime={inputs.fromTime ? inputs.fromTime : eventDetails.start} endDateTime={inputs.toTime ? inputs.toTime : eventDetails.end} sendTimeDataFromChild={handleTimeDataFromChild} />
                                </div>
                            </div>
                            <div className="space-y-1">
                                <div className='flex items-start space-x-2'>
                                    <label className='text-xs sm:text-sm capitalize text-light-700'>{t('appointment type')} :</label>
                                </div>
                                <div ref={dropdownRef} className='text-sm bg-white border border-background-normal rounded-md px-4 py-2 relative'>
                                    <button type="button" onClick={(e) => setShowType(!showType)} className="flex justify-between items-center w-full">
                                        <span className={`mr-1 text-xs sm:text-sm capitalize ${inputs.appointmentTypeIDs.length ? "text-black" : "text-gray-dark"}`}>
                                            {inputs.appointmentTypeIDs.length ? `${inputs.appointmentTypeIDs.length} ${t('selected')}` : t("select")}
                                        </span>
                                        <img src="../../assets/icons/select-down.svg" alt="select-down" />
                                    </button>
                                    {showType && (
                                        <ul className="absolute left-0 w-full min-h-auto max-h-28 overflow-y-auto no-scrollbar z-10 text-background-dark bg-white shadow-md rounded-md top-10">
                                            {appointmentTypeList && appointmentTypeList.map((type, index) => (
                                                <div key={'type'+index} className="flex space-x-2 items-center my-3 px-2">
                                                    <label className="relative flex items-center cursor-pointer">
                                                        <input type="checkbox" name={type.title} value={type.id} onChange={(e) => handleAppointmentType(e, type.id)}className="before:content[''] peer relative h-6 w-6 cursor-pointer appearance-none rounded border border-gray-dark transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-white before:opacity-0 before:transition-opacity checked:border-blue-normal checked:bg-blue-normal checked:before:bg-blue-normal" />
                                                        <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" strokeWidth="1">
                                                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                                                            </svg>
                                                        </span>
                                                    </label>
                                                    <div className="font-normal text-xs sm:text-sm text-light-400 capitalize text-left">{type.title}</div>
                                                </div>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>
                            <div className="space-y-1">
                                <div className='flex items-start space-x-2'>
                                    <label className='text-xs sm:text-sm capitalize text-light-700'>{t('kind of appointment type')} :</label>
                                </div>
                                <div ref={dropdownRef1} className='text-sm bg-white border border-background-normal rounded-md px-4 py-2 relative'>
                                    <button type="button" onClick={(e) => setShowKindType(!showKindType)} className="flex justify-between items-center w-full">
                                        <span className={`mr-1 text-xs sm:text-sm capitalize ${inputs.kindOfAppointmentIDs.length ? "text-black" : "text-gray-dark"}`}>
                                            {inputs.kindOfAppointmentIDs.length ? `${inputs.kindOfAppointmentIDs.length} ${t('selected')}` : t("select")}
                                        </span>
                                        <img src="../../assets/icons/select-down.svg" alt="select-down" />
                                    </button>
                                    {showKindType && (
                                        <ul className="absolute left-0 w-full min-h-auto max-h-28 overflow-y-auto no-scrollbar z-10 text-background-dark bg-white shadow-md rounded-md top-10">
                                            {kindOfAppointmentList && kindOfAppointmentList.map((kind, index) => (
                                                <div key={'kind'+index} className="flex space-x-2 items-center my-3 px-2">
                                                    <label className="relative flex items-center cursor-pointer">
                                                        <input type="checkbox" name={kind.title} value={kind.id} onChange={(e) => handleAppointmentKindType(e, kind.id)}className="before:content[''] peer relative h-6 w-6 cursor-pointer appearance-none rounded border border-gray-dark transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-white before:opacity-0 before:transition-opacity checked:border-blue-normal checked:bg-blue-normal checked:before:bg-blue-normal" />
                                                        <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" strokeWidth="1">
                                                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                                                            </svg>
                                                        </span>
                                                    </label>
                                                    <div className="font-normal text-xs sm:text-sm text-light-400 capitalize text-left">{kind.title}</div>
                                                </div>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>
                        </div>
                        <textarea value={inputs.comment} onChange={handleChange} className="bg-white border border-background-normal rounded-md px-4 py-2 w-full relative flex items-start focus:outline-none" rows={3} columns={9} placeholder={ t("write comments here...")}></textarea>
                    </div>
                    <div className="flex justify-between items-center">
                        <button onClick={(e) => (!isLoad && handleShowCreateModal(e))} className="px-4 py-2 bg-white text-gray-dark4 capitalize font-medium border-2 border-background-normal rounded-lg">
                            { t('close')}
                        </button>
                        <button type={isLoad ? "button" : "submit"} className={(isLoad ? "cursor-not-allowed" : "cursor-pointer") + " px-4 py-2 bg-blue-normal text-white rounded-lg capitalize"}>
                            {isLoad ? (t('Please wait')+'...') : t('create appointment')}
                        </button>
                    </div>
                </div>
            </form>
            {(showMap && markers[0].geocode[0]) && (
                <div className="overflow-y-auto overflow-x-hidden bg-blue-300 bg-opacity-50 fixed flex flex-col top-0 right-0 left-0 z-50 justify-center items-center w-full inset-0 max-h-full">
                    <div className="relative p-4 w-full max-w-5xl max-h-full bg-white rounded-lg">
                        <button onClick={(e) => setShowMap(!showMap)} className="absolute right-1 top-1 border border-gray-400 shadow p-3 bg-white z-20 text-gray-400 rounded-full" >
                            <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                            </svg>    
                        </button>
                        <MapComponent markers={markers} draggable={false} radius={0}/>
                    </div>
                </div>
            )}
        </div>
    );
};

export default EventCopyModal;
